import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMarkup"><Path d="M21 20.4999H3.5V17.8825L7.01074 11.8973" stroke="currentColor"/><Path d="M15.1243 16.6219L12.8867 20.403" stroke="currentColor"/><Path d="M10.8542 2.77319L5.82617 11.2236L16.1988 17.1599L21.4172 8.24976" stroke="currentColor"/></CentralIconBase>;
});

export default IconMarkup;
